<template>
    <footer class="bd-footer text-muted docs-border">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div>© Španovija 2020</div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
  import firebase from 'firebase'

  export default {
    name: 'Footer',
    data: function () {
      return {}
    },
    methods: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue